import { motion } from "framer-motion";
import { GALLERY } from "@/lib/constants";

export default function Gallery() {
  return (
    <section id="galeri" data-testid="gallery-section" className="py-24 lg:py-40 border-t border-ink/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-16 lg:mb-20 flex flex-wrap items-end justify-between gap-8"
        >
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.35em] text-brand-ink mb-4">( Dokumentasi )</p>
            <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.95] text-4xl md:text-6xl lg:text-7xl">
              Galeri <span className="text-stroke">pengerjaan</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm text-ink/50 leading-relaxed">
            Dokumentasi pengerjaan di lapangan. Foto asli akan terus ditambahkan.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {GALLERY.map((g, i) => (
            <motion.figure
              key={g.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 4) * 0.08 }}
              data-testid={`gallery-item-${i}`}
              className="group border border-ink/10 bg-white"
            >
              <div className="overflow-hidden aspect-[4/3]">
                <img
                  src={g.img}
                  alt={g.alt}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <figcaption className="px-4 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-ink/50">
                {g.title}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
